<template>
  <div class="line-items-footer px-i">
    <SubtotalSummary />
    <DiscountSummary />
    <TaxesSummary />
    <TotalSummary />
  </div>
</template>

<script>
import SubtotalSummary from "./SubtotalSummary.vue";
import DiscountSummary from "./DiscountSummary.vue";
import TaxesSummary from "./TaxesSummary.vue";
import TotalSummary from "./TotalSummary.vue";

export default {
  components: {
    SubtotalSummary,
    DiscountSummary,
    TaxesSummary,
    TotalSummary
  }
};
</script>
